export default __webpack_public_path__ + "static/media/g5.06312947.jpg";